import { useEffect, useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import AlertCircle from '@factorialco/f0-react/icons/app/AlertCircle'

import i18n from 'modules/core/lib/i18n'

import { BlockingIssuesModal } from 'modules/integrations/components/SyncButton/Modals/BlockingIssuesModal'
import { Separator } from 'modules/integrations/components/SyncFooter/Separator'
import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useBlockingIssuesLazyQuery } from 'modules/integrations/hooks/SyncContext/useBlockingIssuesLazyQuery'

export const BlockingIssues = () => {
  const { marketplaceIntegration, syncEnabled, contextParameters } = useIntegrationsSyncContext()
  const payrollRunId = contextParameters.payroll_run_id ?? null
  const { fetchBlockingIssues, blockingIssues } = useBlockingIssuesLazyQuery()
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    fetchBlockingIssues()
  }, [marketplaceIntegration?.id, syncEnabled, payrollRunId])

  if (blockingIssues.length === 0) return null

  return (
    <>
      <Box flexDirection="row" cursor="pointer" onClick={() => setIsModalOpen(true)}>
        <Text.Normal color="radicalRed800" size="100">
          <F0Icon icon={AlertCircle} type="warning" />
        </Text.Normal>
        <Text.Normal color="radicalRed1500" size="200" weight="medium" underlined>
          {i18n.tp('integrations.footer.blocking_issues', { count: blockingIssues.length })}
        </Text.Normal>
      </Box>
      <Separator />
      {isModalOpen && (
        <BlockingIssuesModal
          onClose={() => setIsModalOpen(false)}
          blockingIssues={blockingIssues}
        />
      )}
    </>
  )
}
